/**
 * VINYLPAC shared component loader.
 * Fetches an HTML fragment and injects it into the placeholder element,
 * correctly re-executing any <script> tags in the fetched content.
 *
 * Usage:
 *   <div id="accordion-placeholder"></div>
 *   <script>VP.inject('accordion-placeholder', 'accordion.html');</script>
 *
 * inject() returns the underlying promise, resolved once the fragment is
 * in the DOM and its scripts have run -- callers with logic that depends
 * on the injected content (e.g. re-syncing a badge inside nav.html) should
 * chain .then() rather than assuming synchronous availability.
 *
 * cache:'no-store' -- these fragments (nav/header/footer/accordion) are
 * tiny and change often; a stale cached copy silently hides edits from
 * returning visitors with no way to force a refresh. Previously used a
 * '?v=' query param for manual cache-busting, but nothing in the codebase
 * ever set that version, so it was permanently stuck and non-functional.
 */
var VP = (function() {
  function inject(placeholderId, url) {
    var tpl = document.getElementById('vpfrag:' + url.split('?')[0]);
    return (tpl ? Promise.resolve(tpl.innerHTML) : fetch(url, { cache: 'no-store' })
      .then(function(r) { return r.text(); }))
      .then(function(html) {
        var ph = document.getElementById(placeholderId);
        if (!ph) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        // Pull out script content before moving nodes
        var scripts = [];
        tmp.querySelectorAll('script').forEach(function(s) {
          scripts.push({ src: s.getAttribute('src'), code: s.textContent });
          s.remove();
        });
        // Replace placeholder with the HTML (scripts removed)
        ph.outerHTML = tmp.innerHTML;
        // Inline scripts must wait for preceding external dependencies too.
        return scripts.reduce(function(ready, script) {
          return ready.then(function() {
            return new Promise(function(resolve, reject) {
              var el = document.createElement('script');
              if (script.src) {
                el.src = script.src;
                el.async = false;
                el.onload = resolve;
                el.onerror = function() { reject(new Error('Could not load ' + script.src)); };
              } else {
                el.textContent = script.code;
              }
              document.body.appendChild(el);
              if (!script.src) resolve();
            });
          });
        }, Promise.resolve());
      });
  }
  return { inject: inject };
})();

// ? tips: hover or focus shows them; a tap toggles them for touch screens.
document.addEventListener('click', function (event) {
  var tipButton = event.target.closest('.vp-tip-btn');
  document.querySelectorAll('.vp-tip.open').forEach(function (tip) { if (!tipButton || tip !== tipButton.parentNode) tip.classList.remove('open'); });
  if (tipButton) { event.preventDefault(); tipButton.parentNode.classList.toggle('open'); }
});
document.addEventListener('keydown', function (event) { if (event.key === 'Escape') document.querySelectorAll('.vp-tip.open').forEach(function (tip) { tip.classList.remove('open'); }); });
